import React, { useState, useEffect } from 'react';
import { useAuth } from '../auth/Auth';
import "./UsersTasksPage.css";

function GeneralPoolColumn() {
  const { user } = useAuth();
  const [webhooks, setWebhooks] = useState([]);
  const [archivedTasks, setArchivedTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isGeneralPoolCollapsed, setIsGeneralPoolCollapsed] = useState(false);

  const userId = user?.user_id || localStorage.getItem('userId') || '271';

  const archiveTask = async (task) => {
    try {
      const response = await fetch('https://hub2.daolog.net/api/archive-task', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          taskData: task,
          archivedBy: userId,
          archivedAt: new Date().toISOString()
        })
      });

      if (response.ok) {
        // Видаляємо задачу з локального стану
        setWebhooks(prev => prev.filter(w => 
          (w.TaskLink || w.taskLink) !== (task.TaskLink || task.taskLink)
        ));
        
        // Додаємо задачу в локальний архів
        setArchivedTasks(prev => [...prev, {
          ...task,
          archivedBy: userId,
          archivedAt: new Date().toISOString()
        }]);
        
        console.log('Задачу успішно архівовано');
      } else {
        console.error('Помилка архівування задачі');
      }
    } catch (error) {
      console.error('Помилка архівування:', error);
    }
  };

  // Функція для оновлення вебхуків
  const refreshWebhooks = async () => {
    try {
      const tokenResponse = await fetch(`https://hub2.daolog.net/api/user-token/${userId}`);
      if (!tokenResponse.ok) return;
      const tokenData = await tokenResponse.json();
      const userToken = tokenData.token;
      if (!userToken) return;
      
      const webhooksResponse = await fetch(`https://hub2.daolog.net/api/pf-webhooks-by-token/${userToken}`);
      if (!webhooksResponse.ok) return;
      const webhooksData = await webhooksResponse.json();
      
      if (webhooksData.success) {
        setWebhooks(webhooksData.webhooks);
      }
    } catch (error) {
      console.error('Помилка оновлення вебхуків:', error);
    }
  };

  // Слухаємо зміни в архіві та оновлюємо вебхуки
  useEffect(() => {
    refreshWebhooks();
  }, [archivedTasks.length]);

  const calculateEndTime = (receivedAt, taskTimer) => {
    if (!taskTimer) return null;
    const startTime = new Date(receivedAt);
    const timerMatch = taskTimer.match(/(\d+)\s*(хв|год)/);
    if (!timerMatch) return null;
    const value = parseInt(timerMatch[1]);
    const unit = timerMatch[2];
    if (unit === 'хв') {
      startTime.setMinutes(startTime.getMinutes() + value);
    } else if (unit === 'год') {
      startTime.setHours(startTime.getHours() + value);
    }
    return startTime;
  };

  const calculateTimeLeft = (endTime, receivedAt) => {
    const now = new Date();
    const difference = endTime - now;
    
    if (difference <= 0) {
      const timeInPool = now - new Date(receivedAt);
      const hours = Math.floor(timeInPool / (1000 * 60 * 60));
      const minutes = Math.floor((timeInPool % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeInPool % (1000 * 60)) / 1000);
      
      return {
        expired: true,
        text: `+${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
        percentage: 100,
        endTime: endTime,
        timeInPool: timeInPool
      };
    }
    
    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    const totalTime = endTime - new Date(receivedAt);
    const percentage = totalTime > 0 ? 100 - (difference / totalTime * 100) : 0;
    
    return {
      expired: false,
      text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      percentage: Math.min(Math.max(percentage, 0), 100),
      endTime: endTime
    };
  };

  const formatStartDate = (startdate) => {
    if (!startdate) return '';
    const date = new Date(startdate.replace(', ', 'T'));
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const calculateTimeInStatus = (receivedAt) => {
    const receivedTime = new Date(receivedAt);
    const now = new Date();
    const diffMs = now - receivedTime;
    
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hours > 0) {
      return `${hours}год ${minutes}хв`;
    }
    return `${minutes}хв`;
  };

  // Функція для отримання посилань архівованих задач
  const getArchivedTaskLinks = () => {
    return archivedTasks.map(task => task.TaskLink || task.taskLink);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }
      try {
        setError('');
        
        // Отримуємо токен користувача
        const tokenResponse = await fetch(`https://hub2.daolog.net/api/user-token/${userId}`);
        if (!tokenResponse.ok) throw new Error(`Помилка отримання токену: ${tokenResponse.status}`);
        const tokenData = await tokenResponse.json();
        const userToken = tokenData.token;
        if (!userToken) throw new Error('Токен користувача не знайдено');
        
        // Отримуємо вебхуки та архів паралельно
        const [webhooksResponse, archiveResponse] = await Promise.all([
          fetch(`https://hub2.daolog.net/api/pf-webhooks-by-token/${userToken}`),
          fetch(`https://hub2.daolog.net/api/archived-tasks`)
        ]);
        
        if (!webhooksResponse.ok) throw new Error(`Помилка отримання вебхуків: ${webhooksResponse.status}`);
        
        const webhooksData = await webhooksResponse.json();
        const archiveData = await archiveResponse.json();
        
        if (webhooksData.success) {
          setWebhooks(webhooksData.webhooks);
        } else {
          setError('Невірний формат даних від сервера');
        }

        if (archiveData.success) {
          setArchivedTasks(archiveData.archivedTasks || []);
        }
        
      } catch (error) {
        console.error('Помилка завантаження даних:', error);
        setError(`Помилка завантаження даних: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    const interval = setInterval(fetchData, 10000); // Збільшено інтервал до 10 секунд
    return () => clearInterval(interval);
  }, [userId]);

  const groupedByTask = webhooks.reduce((acc, webhook) => {
    const taskLink = webhook.TaskLink || webhook.taskLink || 'unknown';
    
    // Пропускаємо задачі, які вже в архіві
    const archivedLinks = getArchivedTaskLinks();
    if (archivedLinks.includes(taskLink)) {
      return acc;
    }
    
    if (!acc[taskLink]) acc[taskLink] = [];
    acc[taskLink].push(webhook);
    return acc;
  }, {});

  const latestWebhooks = Object.entries(groupedByTask).map(([taskLink, taskWebhooks]) => {
    taskWebhooks.sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));
    return taskWebhooks[0];
  });

  const generalPoolTasks = latestWebhooks.filter(task => {
    const taskStatus = String(task.TaskStatus || task.taskStatus || '');
    const taskPersonalPoint = String(task.TaskPersonalPoint || task.taskPersonalPoint || '');
    const taskName = String(task.TaskName || task.taskName || '');
    const implementerTask = String(task.implementer_task || task.ImplementerTask || '');
    const taskLink = String(task.TaskLink || task.taskLink || '');
    
    const isNotPersonal = taskPersonalPoint === 'Ні' || taskPersonalPoint === 'Нет' || taskPersonalPoint === 'No';
    const isGeneralPoolStatus = taskStatus === 'Черговому' || taskStatus === 'Дежурному';
    const isNotImplementerTask = implementerTask !== 'Yes' && implementerTask !== 'Так';
    
    const excludedNames = ['Заявка №', 'Oбед', 'Обід', 'Обед', 'Чергування / Дежурство -- Менторство', 'Чергування'];
    
    // Виправлена перевірка виключень - шукаємо цілі слова
    const shouldExclude = excludedNames.some(name => {
      const nameTrimmed = name.trim().toLowerCase();
      // Використовуємо регулярний вираз для пошуку цілих слів
      const regex = new RegExp(`(^|\\s)${nameTrimmed}(\\s|$)`, 'i');
      return regex.test(taskName);
    });
    
    return isGeneralPoolStatus && isNotPersonal && isNotImplementerTask && !shouldExclude;
  });

  const TaskItem = ({ task }) => {
    const isBlocker = task.isBlocker === 'Термінове' || task.IsBlocker === 'Термінове' ||
                      task.isBlocker === 'Срочная' || task.IsBlocker === 'Срочная';
    const taskLink = task.TaskLink || task.taskLink;
    const taskName = task.TaskName || task.taskName || 'Без назви';
    const projectName = task.ProjectName || task.projectName || '';
    const startdate = task.startdate;
        
    let endTime, timeLeft;
    if (startdate) {
      const startDateTime = new Date(startdate.replace(', ', 'T'));
      endTime = new Date(startDateTime.getTime() + 10 * 60 * 1000); 
      timeLeft = calculateTimeLeft(endTime, startdate.replace(', ', 'T'));
    }

    const isExpired = timeLeft?.expired;
    const showTimer = timeLeft && (!isExpired || isExpired);

    const handleTaskClick = () => {
      window.open(taskLink, '_blank');
    };

    const handleArchiveClick = (e) => {
      e.stopPropagation();
      if (window.confirm('Ви дійсно хочете архівувати цю задачу?')) {
        archiveTask(task);
      }
    };

    return (
      <div 
        className={`task-item ${isBlocker ? 'blocker' : ''} ${isExpired ? 'expired' : ''}`}
        onClick={handleTaskClick}
        title={`${taskName}${projectName ? ` (${projectName})` : ''}`}
        style={{ cursor: 'pointer', position: 'relative' }}
      >
        {showTimer && !isExpired && (
          <div 
            className="task-progress" 
            style={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: `${timeLeft.percentage}%`,
              backgroundColor: 'rgba(255, 0, 0, 0.1)',
              transition: 'width 1s linear',
              zIndex: 0
            }}
          />
        )}
        {showTimer && isExpired && (
          <div 
            className="task-progress-expired" 
            style={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              backgroundColor: 'rgba(255, 0, 0, 0.2)',
              zIndex: 0
            }}
          />
        )}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div className="task-header">
            <div className="task-name" title={taskName}>
              {taskName}
            </div>
            <button 
              className="archive-btn"
              onClick={handleArchiveClick}
              title="Архівувати задачу"
            >
              📁
            </button>
          </div>
          <div className="task-time">
            {showTimer && (
              <span 
                style={{ 
                  marginRight: '8px', 
                  fontWeight: 'bold',
                  color: isExpired ? '#ff4444' : 'inherit'
                }}
              >
                {timeLeft.text}
                {isExpired && ' в пулі'}
              </span>
            )}
            {startdate && <span>{formatStartDate(startdate)}</span>}
            {!startdate && !showTimer && calculateTimeInStatus(task.receivedAt)}
          </div>
          {isBlocker && (
            <div className="task-blocker">Термінове</div>
          )}
          {projectName && (
            <div className="task-project" title={projectName}>
              {projectName}
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) return <div className="loading">Завантаження...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="general-pool-section">
      <div className="pool-header">
        <div className="pool-header-left">
          <h2 className="pool-title">
            Загальний пул (з таймерами)
            <span className="task-count">({generalPoolTasks.length})</span>
          </h2>
        </div>
        <button 
          className="collapse-btn"
          onClick={() => setIsGeneralPoolCollapsed(!isGeneralPoolCollapsed)}
          aria-label={isGeneralPoolCollapsed ? "Розгорнути" : "Згорнути"}
        >
          {isGeneralPoolCollapsed ? '▼' : '▲'}
        </button>
      </div>
      
      {!isGeneralPoolCollapsed && (
        <div className="general-pool-tasks">
          {generalPoolTasks.length === 0 ? (
            <div className="no-tasks">Немає завдань у загальному пулі</div>
          ) : (
            generalPoolTasks.map(task => (
              <TaskItem key={task.TaskLink || task.taskLink} task={task} />
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default GeneralPoolColumn;